export enum textFormat {all = 1, chinese, english, number}
export enum widthE {full = 1, half}
/* 只读，隐藏 */
export enum permissionE {disabled = 1, hidden}
export enum validateE {required = 1, noRepeat}
export enum memberPermissionE {readOnly = 1, manage, noPermission}
export enum selectE {radio = 1, checkbox}
export enum arrangeE {row = 1, column}
